import { useMemo } from "react";
import { isMountingCompatibleWithSuctionCup } from "3d/helpers";
import { selectors, useAppSelector } from "store";
export var useCupMountingOptions = function (nodeIds) {
    var systemDataDefineParameters = useAppSelector(selectors.selectSystemDataDefineParameters);
    var selectedCupMountings = useAppSelector(selectors.selectSelectedCupMountings(nodeIds));
    var selectedCups = useAppSelector(selectors.selectSelectedCups(nodeIds));
    var cupMountingOptions = useMemo(function () {
        if (!(systemDataDefineParameters === null || systemDataDefineParameters === void 0 ? void 0 : systemDataDefineParameters.cupMountingComponents))
            return [];
        var cupMountingOptionsList = Object.values(systemDataDefineParameters.cupMountingComponents).filter(function (component) {
            return selectedCups.every(function (currentlySelectedCup) {
                return isMountingCompatibleWithSuctionCup(currentlySelectedCup, component) ||
                    selectedCupMountings
                        .map(function (mounting) { return mounting === null || mounting === void 0 ? void 0 : mounting.value; })
                        .includes(component.value);
            });
        });
        return cupMountingOptionsList;
    }, [
        selectedCupMountings,
        selectedCups,
        systemDataDefineParameters === null || systemDataDefineParameters === void 0 ? void 0 : systemDataDefineParameters.cupMountingComponents,
    ]);
    var selectedCupMountingOptions = useMemo(function () {
        return cupMountingOptions.filter(function (option) {
            return option.value &&
                selectedCupMountings
                    .map(function (mounting) { return mounting === null || mounting === void 0 ? void 0 : mounting.value; })
                    .includes(option.value);
        });
    }, [cupMountingOptions, selectedCupMountings]);
    return { cupMountingOptions: cupMountingOptions, selectedCupMountingOptions: selectedCupMountingOptions };
};
